<script>
// Components
import { AppAvatar } from '@/components/ui/avatar'

export default {
  functional: true,

  props: {
    image: {
      type: String,
      default: null
    },

    name: {
      type: String,
      default: ''
    },

    tel: {
      type: String,
      default: ''
    }
  },

  render(h, { data, props }) {
    return (
      <div {...data}>
        <el-row
          type="flex"
          gutter={16}
          align="middle"
          style={{ flexWrap: 'wrap' }}
        >
          <el-col span={null}>
            <AppAvatar
              size={64}
              src={props.image}
              style={{ display: 'block' }}
            ></AppAvatar>
          </el-col>
          <el-col span={null} style={{ flex: '1' }}>
            <div style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
              {props.name}
            </div>
            <div>Tel: {props.tel}</div>
          </el-col>
        </el-row>
      </div>
    )
  }
}
</script>
